import request from '@/utils/request'

// 获取资产概览
export function getAssets(options = {}) {
  return request({ url: '/ftx/account/assets', method: 'get', ...options })
}

// 获取充值地址
export function getDepositAddress() {
  return request({ url: '/ftx/account/deposit/address', method: 'get' })
}

// 提交入金申请
export function submitDeposit(data) {
  return request({ url: '/ftx/account/deposit/submit', method: 'post', data })
}

// 获取入金记录
export function getDepositRecords(params) {
  return request({ url: '/ftx/account/deposit/records', method: 'get', params })
}

// 提交出金申请
export function submitWithdraw(data) {
  return request({ url: '/ftx/account/withdraw/submit', method: 'post', data })
}

// 获取出金记录
export function getWithdrawRecords(params) {
  return request({ url: '/ftx/account/withdraw/records', method: 'get', params })
}

// 获取兑换汇率
export function getExchangeRate(params) {
  return request({ url: '/ftx/account/exchange/rate', method: 'get', params })
}

// 提交兑换
export function doExchange(data) {
  return request({ url: '/ftx/account/exchange/submit', method: 'post', data })
}

// 获取兑换记录
export function getExchangeRecords(params) {
  return request({ url: '/ftx/account/exchange/records', method: 'get', params })
}

// 获取资金流水
export function getTransactions(params) {
  return request({ url: '/ftx/account/transactions', method: 'get', params })
}

// 获取邀请统计
export function getInviteStats() {
  return request({ url: '/ftx/account/invite-stats', method: 'get' })
}

// 获取返佣记录列表
export function getRebateRecords(params) {
  return request({ url: '/ftx/account/rebate-records', method: 'get', params })
}

// 获取邀请用户列表
export function getInvitedList(params) {
  return request({ url: '/ftx/account/invited-list', method: 'get', params })
}
